// Environment Configuration
export const config = {
  shopify: {
    storeUrl: import.meta.env.VITE_SHOPIFY_STORE_URL || "",
    storefrontToken: import.meta.env.VITE_SHOPIFY_STOREFRONT_TOKEN || "",
    collectionId: import.meta.env.VITE_SHOPIFY_COLLECTION_ID || "",
    graphqlEndpoint: `https://${import.meta.env.VITE_SHOPIFY_STORE_URL}/api/${
      import.meta.env.VITE_SHOPIFY_API_VERSION || "2025-10"
    }/graphql.json`,
  },
  qrCode: {
    apiUrl: import.meta.env.VITE_QR_CODE_API_URL,
  },
  websocket: {
    url: import.meta.env.VITE_WEBSOCKET_URL || "ws://localhost:8080",
  },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "",
  },
  youtube: {
    videoId: import.meta.env.VITE_YOUTUBE_VIDEO_ID || "dQw4w9WgXcQ",
  },
} as const;

/**
 * Get the Shopify collection ID from property or fallback to environment variable
 * @param property - Optional property object (with collectionId property)
 * @returns The collection ID to use
 */
export function getCollectionId(
  property?: { collectionId?: string } | null
): string {
  // First try property collectionId
  if (property?.collectionId) {
    return property.collectionId;
  }
  // Fallback to environment variable
  return config.shopify.collectionId;
}

// Validate required environment variables
// Note: VITE_SHOPIFY_COLLECTION_ID is now optional if provided via property collectionId
export const validateConfig = (collectionId?: string): void => {
  const requiredVars = [
    "VITE_SHOPIFY_STORE_URL",
    "VITE_SHOPIFY_STOREFRONT_TOKEN",
  ];

  const missingVars = requiredVars.filter(
    (varName) => !import.meta.env[varName]
  );

  // Check if collection ID is available (either from param or env)
  if (!collectionId && !config.shopify.collectionId) {
    missingVars.push("VITE_SHOPIFY_COLLECTION_ID (or property collectionId)");
  }

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(", ")}`
    );
  }
};
